import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import { useMediaQuery } from 'react-responsive'

import { ApprovalsIcon, CalendarNavIcon, GridPreviewIcon } from 'Icons'

import ToggleGroup from './Common/ToggleGroup'

export type TabViewValue = 'calendar' | 'approval' | 'instagramGrid'

// SKE-3806: each view gets the platform left-nav icon (copied verbatim from the
// dashboard sidebar), recoloured by the toggle-group's `nav` appearance —
// purple when selected, grey otherwise (the SVGs use fill="currentColor").
const TAB_ICONS: Record<
  TabViewValue,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  approval: ApprovalsIcon,
  calendar: CalendarNavIcon,
  instagramGrid: GridPreviewIcon,
}

const tabIcon = (value: TabViewValue) => {
  const Icon = TAB_ICONS[value]
  return <Icon aria-hidden="true" />
}

export interface NavbarTabView {
  defaultValue: TabViewValue
  leftItem: { value: TabViewValue; label: string }
  middleItem?: { value: TabViewValue; label: string }
  rightItem: { value: TabViewValue; label: string }
  onViewChange: (view: TabViewValue) => void
}
export interface NavbarProps {
  logo: string
  name: string
  view?: NavbarTabView
}

const Navbar: React.FC<NavbarProps & React.HTMLAttributes<HTMLDivElement>> = ({
  logo,
  name,
  view,
  ...props
}) => {
  const isMobile = useMediaQuery({ maxWidth: 906 })

  return (
    <div
      className={cn(
        'relative z-[3] flex h-[70px] items-center bg-white px-[76px] shadow-[0_1px_5px_rgba(0,0,0,0.25)] max-[1280px]:px-[38px]',
        props.className
      )}
    >
      <div className="min-[1280px]:mx-auto min-[1280px]:w-full min-[1280px]:max-w-[1280px]">
        <div className="flex items-center">
          <img
            src={logo}
            alt={name}
            className="mr-5 w-[50px] rounded-[5px] object-contain"
          />
          <h1 className="text-base font-medium max-[767px]:text-xs">{name}</h1>
        </div>

        {!isMobile && view && (
          <ToggleGroup
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            appearance="nav"
            defaultValue={view.defaultValue}
            leftItem={{
              value: view.leftItem.value,
              label: view.leftItem.label,
              icon: tabIcon(view.leftItem.value),
            }}
            {...(view.middleItem
              ? {
                  middleItem: {
                    value: view.middleItem.value,
                    label: view.middleItem.label,
                    icon: tabIcon(view.middleItem.value),
                  },
                }
              : undefined)}
            rightItem={{
              value: view.rightItem.value,
              label: view.rightItem.label,
              icon: tabIcon(view.rightItem.value),
            }}
            onValueChange={(value) => view.onViewChange(value as TabViewValue)}
            size="md"
          />
        )}
      </div>
    </div>
  )
}

export default Navbar
